import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Metric {
  icon: string;
  value: string;
  label: string;
  change: string;
  color: string;
}

interface ImpactMetricsProps {
  className?: string;
}

const ImpactMetrics: React.FC<ImpactMetricsProps> = ({ className = '' }) => {
  const metrics: Metric[] = [
    {
      icon: 'CloudIcon',
      value: '2.4M+',
      label: 'Tons CO₂ Sequestered',
      change: '+18% this quarter',
      color: 'success',
    },
    {
      icon: 'BeakerIcon',
      value: '850M',
      label: 'Liters Water Conserved',
      change: '+25% this quarter',
      color: 'trust',
    },
    {
      icon: 'ChartBarIcon',
      value: '92%',
      label: 'Average ESG Score Improvement',
      change: '+12% this quarter',
      color: 'accent',
    },
    {
      icon: 'BuildingOfficeIcon',
      value: '150+',
      label: 'Organizations Impacted',
      change: '+35 new clients',
      color: 'conversion',
    },
  ];

  return (
    <div className={`grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 ${className}`}>
      {metrics.map((metric, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-natural transition-all duration-300"
        >
          <div className={`w-12 h-12 bg-${metric.color}/10 rounded-lg flex items-center justify-center mb-4`}>
            <Icon
              name={metric.icon as any}
              size={24}
              className={`text-${metric.color}`}
            />
          </div>
          <div className="text-3xl font-heading font-bold text-text-primary mb-2">
            {metric.value}
          </div>
          <div className="text-text-primary font-medium mb-2">{metric.label}</div>
          <div className="text-sm text-success flex items-center gap-1">
            <Icon name="ArrowTrendingUpIcon" size={16} />
            <span>{metric.change}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImpactMetrics;